import React, { useState } from "react";
import "./VisionIgnite.css";

const VisionIgnite = () => {
  
  const faqs = [
  {
    question: "Will this get rid of my glasses completely?",
    answer:
      "The goal is to reduce dependence where possible by improving habits and visual function. We don't make blanket guarantees — every eye is different, every prescription has its own story. What we can promise is a structured system built on habits that are actually worth building regardless of outcome."
  },
  {
    question: "How much time does this actually take?",
    answer:
      "The core daily routines are 10–15 minutes. The rest are lifestyle habits — screen breaks, outdoor time, sleep posture — woven into what you're already doing. This isn't a second job. It's a new default."
  },
  {
    question: "I have a high prescription. Can this still help?",
    answer:
      "Vision Ignite works alongside your existing eye care, not instead of it. Higher prescription or more accumulated screen strain often means more room for lifestyle habits to make a real difference. We recommend you continue seeing your eye-care professional while building this practice."
  },
  {
    question: "Is this only for athletes or students?",
    answer:
      "Not at all. Vision Ignite is for anyone who spends significant time on screens — which in 2024 is basically everyone. No athletic background or prior knowledge required."
  },
  {
    question: "What happens after I pay?",
    answer:
      "You'll get immediate access to the full Vision Ignite system through our learning platform. Start the Eye Health Reset Foundation on day one and follow the daily ritual library from there. The community is live and waiting."
  }
];

const [openIndex, setOpenIndex] = useState(0);
  return (
    <main className="vision-page">

      {/* HERO */}
      <section className="vision-section">
  <div className="vision-container vision-hero">

    {/* LEFT CONTENT */}
    <div className="vision-left">

      <div className="vision-badge">
        VISION IGNITE 
      </div>

      <h1 className="vision-title">
        Your glasses prescription
        <br />
        goes up every year.
        <br />
        <span>That's not fate.</span>
      </h1>

      <p className="vision-subtitle">
        A 10-minute daily training system to reduce screen strain,
        rebuild distance vision, and stop letting modern life slowly
        wreck your eyesight.
      </p>

      <div className="vision-buttons">
        <a
          href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f"
          className="vision-btn-primary"
        >
           Life looks better in focus →
        </a>
      </div>

    </div>

    {/* RIGHT IMAGE */}
    <div className="vision-right">
      <img
        src="/Hero/Vision.png"
        alt="Vision Ignite"
      />
    </div>
   </div>
   <div className="vision-meta">
    <p className="vision-payment">
      🛡 One-time payment · No subscription · Lifetime access
    </p>

    <div className="vision-features">
      <span>10–15 min/day</span>
      <span>Monthly acuity tracking</span>
      <span>5 science-backed pillars</span>
      <span>Community support</span>
    </div>
   </div>

  <div className="vision-problem">

  <span className="vision-problem-tag">
    THE PROBLEM
  </span>

  <h2 className="vision-problem-title">
    Your eyes are putting in 10-hour days with zero recovery time
  </h2>

  <p className="vision-problem-description">
    You evolved to scan horizons. Instead you're staring at screens
    30cm from your face for most of your waking life. That's not just
    uncomfortable — it's reshaping how your eyes work. And it compounds
    every year you don't address it.
  </p>

  <div className="vision-problem-grid">

    <div className="vision-problem-card">
      <div className="problem-icon">😵</div>
      <p>End-of-day blurriness that takes time to clear</p>
    </div>

    <div className="vision-problem-card">
      <div className="problem-icon">😡</div>
      <p>Headaches that build through long focus sessions</p>
    </div>

    <div className="vision-problem-card">
      <div className="problem-icon">📈</div>
      <p>A prescription that creeps up every single year</p>
    </div>

    <div className="vision-problem-card">
      <div className="problem-icon">😴</div>
      <p>Digital fatigue that drains your energy by 3pm</p>
    </div>

  </div>

</div>
<div className="vision-final-banner">

  <h2 className="vision-final-title">
    Every year you wait,
    <br />
    your eyes <span>adapt further</span> to screens.
  </h2>

  <p className="vision-final-description">
    The earlier you build these habits, the more you can protect
    and recover. This is the system to do it.
  </p>

  <a
    href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f"
    className="vision-final-btn"
  >
     Make every day clearer →
  </a>

  <p className="vision-final-note">
    One-time payment. No recurring fees. Start in minutes.
  </p>

</div>
<div className="vision-method">

  <span className="vision-method-tag">
    THE METHOD
  </span>

  <h2 className="vision-method-title">
    Five pillars. Daily practice. Measurable change.
  </h2>

  <p className="vision-method-description">
    Vision Ignite isn't a gadget or a supplement. It's a structured
    training system built on five pillars that address how your eyes
    actually work — and how modern habits break them.
  </p>

  <div className="vision-method-grid">

    <div className="vision-method-card">
      <span className="vision-method-number">01</span>
      <h3>Eye relaxation</h3>
      <p>
        Palming, breath, and nervous-system techniques to release
        tension that's been accumulating for years.
      </p>
    </div>

    <div className="vision-method-card">
      <span className="vision-method-number">02</span>
      <h3>Focus flexibility</h3>
      <p>
        Near-far shifting drills to undo the focusing rigidity that
        screens bake in over time.
      </p>
    </div>

    <div className="vision-method-card">
      <span className="vision-method-number">03</span>
      <h3>Distance vision</h3>
      <p>
        Rebuild the habit of looking far — with natural light,
        open space, and real depth.
      </p>
    </div>

    <div className="vision-method-card">
      <span className="vision-method-number">04</span>
      <h3>Visual awareness</h3>
      <p>
        Peripheral sharpness, eye movement quality, and the
        kind of attention that doesn't fatigue easily.
      </p>
    </div>

    <div className="vision-method-card">
      <span className="vision-method-number">05</span>
      <h3>Recovery habits</h3>
      <p>
        Sleep, sunlight, and screen-break routines that protect
        your progress and compound over months.
      </p>
    </div>

  </div>

</div>
<div className="vision-included">

  <span className="vision-included-tag">
    WHAT YOU GET
  </span>

  <h2 className="vision-included-title">
    A complete system — not a loose collection of tips
  </h2>

  <div className="vision-included-list">

    <div className="vision-included-item">
      <div className="vision-check">✓</div>
      <div>
        <h3>Eye Health Reset Foundation</h3>
        <p>
          Understand how strain builds, how vision works,
          and how to train safely from day one.
        </p>
      </div>
    </div>

    <div className="vision-included-item">
      <div className="vision-check">✓</div>
      <div>
        <h3>Daily vision ritual library</h3>
        <p>
          Guided protocols for palming, sunning, distance viewing,
          and focus drills.
        </p>
      </div>
    </div>

    <div className="vision-included-item">
      <div className="vision-check">✓</div>
      <div>
        <h3>Visual acuity tracking</h3>
        <p>
          Measure your baseline and track real changes over time.
        </p>
      </div>
    </div>

    <div className="vision-included-item">
      <div className="vision-check">✓</div>
      <div>
        <h3>Monthly practice challenges</h3>
        <p>
          Themed sprints that keep your practice interesting
          month after month.
        </p>
      </div>
    </div>

    <div className="vision-included-item">
      <div className="vision-check">✓</div>
      <div>
        <h3>Community + accountability</h3>
        <p>
          Share progress, stay consistent, and learn from others.
        </p>
      </div>
    </div>

    <div className="vision-included-item">
      <div className="vision-check">✓</div>
      <div>
        <h3>Upgrade path</h3>
        <p>
          When you're ready for deeper guidance,
          a clear next step is waiting for you.
        </p>
      </div>
    </div>

  </div>

</div>
<div className="vision-audience">

  <span className="vision-audience-tag">
    WHO IT'S FOR
  </span>

  <h2 className="vision-audience-title">
    Anyone whose eyes are paying the price of modern life
  </h2>

  <div className="vision-audience-grid">

    <div className="vision-audience-card">
      <div className="vision-audience-icon">🎓</div>
      <h3>Students</h3>
      <p>
        Build better screen habits and protect your focus during
        the years that matter most.
      </p>
    </div>

    <div className="vision-audience-card">
      <div className="vision-audience-icon">💻</div>
      <h3>Working professionals</h3>
      <p>
        Reduce daily strain and recover distance-vision habits
        after long workdays.
      </p>
    </div>

    <div className="vision-audience-card">
      <div className="vision-audience-icon">👨‍👩‍👧</div>
      <h3>Parents & families</h3>
      <p>
        Build visual-health routines the whole family can follow.
      </p>
    </div>

  </div>

</div>
<div className="vision-pricing">

  <span className="vision-pricing-tag">
    PRICING
  </span>

  <h2 className="vision-pricing-title">
    One payment. Lifetime access. No fine print.
  </h2>

  <div className="vision-price-card">

    <div className="vision-price-badge">
      MOST PEOPLE START HERE
    </div>

    <div className="vision-price">
      See Free
    </div>

    <p className="vision-price-subtitle">
      One-time payment · No subscription · Lifetime access
    </p>

    <div className="vision-price-content">

      <ul className="vision-price-list">
        <li>✓ Eye Health Reset Foundation</li>
        <li>✓ Daily vision training library</li>
        <li>✓ Monthly practice challenges</li>
        <li>✓ Visual acuity tracking guidance</li>
        <li>✓ Community + accountability</li>
        <li>✓ Upgrade path access</li>
      </ul>

      <a
        href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f"
        className="vision-price-btn"
      >
        Join the top 1% who train vision
      </a>

    </div>

    <div className="vision-price-note">
      Vision Ignite is an educational and training membership —
      not a medical treatment. Results vary by age, prescription,
      habits and consistency.
    </div>

  </div>

</div>
<div className="vision-faq">

  <span className="vision-faq-tag">
    FAQ
  </span>

  <h2 className="vision-faq-title">
    Honest answers, no fluff
  </h2>

  <div className="vision-faq-list">

    {faqs.map((faq, index) => (
      <div
        className="vision-faq-item"
        key={index}
      >
        <div
          className="vision-faq-header"
          onClick={() =>
            setOpenIndex(
              openIndex === index ? null : index
            )
          }
        >
          <h3>{faq.question}</h3>

          <span
            className={`vision-faq-arrow ${
              openIndex === index ? "open" : ""
            }`}
          >
            ▾
          </span>
        </div>

        {openIndex === index && (
          <p className="vision-faq-answer">
            {faq.answer}
          </p>
        )}
      </div>
    ))}

  </div>

</div>
<div className="vision-final-cta">

  <h2 className="vision-final-cta-title">
    Six months from now,
    <br />
    your eyes can feel <span>different.</span>
  </h2>

  <p className="vision-final-cta-description">
    The only thing standing between you and healthier
    vision habits is starting. Ten minutes today is enough.
  </p>

  <a
    href="https://learn.forgeyourpeak.in/web/checkout/69e059ceca745f9ed6895c9f"
    className="vision-final-cta-btn"
  >
     Join the top 1% who train vision →
  </a>

  <p className="vision-final-cta-payment">
    🛡 One-time payment · No subscription · Lifetime access
  </p>

  <p className="vision-final-cta-note">
    Not a medical treatment. Results vary. Always work with
    your eye-care professional.
  </p>

</div>

</section>

    </main>
  );
};

export default VisionIgnite;